<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wjgedy/tc-custom/9780226623672.jpg?1737195126503" alt="This image is the cover for the book Idols of ISIS"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Idols of ISIS
      </h1>
      <p class="bookDescription body article font2">
        <p>In 2015, the Islamic State released a video of men smashing sculptures in Iraq’s Mosul Museum as part of a mission to cleanse the world of idolatry. This book unpacks three key facets of that event: the status and power of images, the political importance of museums, and the efficacy of videos in furthering an ideological agenda through the internet.<br/><br/> Beginning with the Islamic State’s claim that the smashed objects were idols of the “age of ignorance,” Aaron Tugendhaft questions whether there can be any political life without idolatry. He then explores the various roles Mesopotamian sculpture has played in European imperial competition, the development of artistic modernism, and the formation of Iraqi national identity, showing how this history reverberates in the choice of the Mosul Museum as performance stage. Finally, he compares the Islamic State’s production of images to the ways in which images circulated in ancient Assyria and asks how digitization has transformed politics in the age of social media. An elegant and accessibly written introduction to the complexities of such events, <i>The Idols of ISIS</i> is ideal for students and readers seeking a richer cultural perspective than the media usually provides.<br/>  </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Aaron Tugendhaft
      </h2>
      
      <p class="authorDescription body article"><B>Aaron Tugendhaft</B> teaches humanities at Bard College Berlin. He is the author of <I>Baal and the Politics of Poetry</I> and co-editor of <I>Idol Anxiety</I>.<br> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?320e5466